import { useCollectStore } from '@/stores/collect';

export default {
  data() {
    return {
      collectStore: useCollectStore()
    };
  }
};
